<template>
  <div>
    <div style="position: absolute; top: 0; right: 5px">
      <v-btn @click="$router.push('/')" icon small>
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <v-form class="mt-4" v-model="formValid" ref="myForm">
      <v-layout row wrap>
        <v-flex xs12 sm6 class="pa-2">
          <v-card class="ma-2 pa-2 card-rounded" flat>
            <v-card-title>
              <h3 class="primary--text">{{ this.$t('profile.Profile') }}</h3>
            </v-card-title>
            <v-card-text>
              <image-input v-model="avatar" class="mb-5">
                <div slot="activator">
                  <v-avatar
                    v-if="!avatar"
                    v-ripple
                    size="150px"
                    class="grey lighten-3 mb-3"
                  >
                    <span>{{ this.$t('profile.AddAvatar') }}</span>
                  </v-avatar>
                  <v-avatar v-else v-ripple size="150px" class="mb-3">
                    <img :src="avatar" alt="avatar" />
                  </v-avatar>
                </div>
              </image-input>
              <v-layout>
                <v-flex xs6 class="mr-1">
                  <span class="caption grey--text text--darken-1">{{
                    $t('profile.FirstName')
                  }}</span>
                  <v-text-field
                    class="thin-border"
                    solo
                    v-model="editedUser.firstName"
                    required
                    :rules="mandatoryRule"
                  />
                </v-flex>
                <v-flex xs6>
                  <span class="caption grey--text text--darken-1">{{
                    $t('profile.LastName')
                  }}</span>
                  <v-text-field
                    v-model="editedUser.lastName"
                    :label="$t('profile.LastName')"
                    required
                    :rules="mandatoryRule"
                    class="thin-border"
                    solo
                  />
                </v-flex>
              </v-layout>
              <span class="caption grey--text text--darken-1">{{
                $t('profile.Email')
              }}</span>
              <v-text-field
                v-model="editedUser.email"
                :label="$t('profile.Email')"
                required
                :rules="mandatoryRule"
                class="thin-border"
                solo
              />
              <span class="caption grey--text text--darken-1">{{
                $t('profile.LicenseNumber')
              }}</span>
              <v-text-field
                disabled
                v-model="editedUser.license"
                :label="$t('profile.LicenseNumber')"
                required
                :rules="mandatoryRule"
                class="thin-border"
                solo
              />
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 class="pa-2">
          <v-card class="ma-2 pa-2 card-rounded" flat>
            <v-card-title>
              <h3 class="primary--text">Especialidade</h3>
            </v-card-title>
            <v-card-text>
              <span class="caption grey--text text--darken-1">{{
                $t('profile.Specialty')
              }}</span>
              <v-select
                v-model="editedUser.specialty"
                :disabled="!isSuperAdmin"
                :label="$t('profile.Specialty')"
                :items="specialtySelections"
                class="thin-border"
                solo
              />
              <span class="caption grey--text text--darken-1">{{
                $t('profile.Role')
              }}</span>
              <v-select
                v-model="editedUser.roles"
                :disabled="!isSuperAdmin"
                :label="$t('profile.Role')"
                multiple
                :items="roleSelections"
                class="thin-border"
                solo
              />
              <v-layout>
                <v-flex xs8>
                  <v-menu
                    v-model="datePicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <span
                        class="caption grey--text text--darken-1 ml-4 pl-2"
                        >{{ $t('profile.ResidencyStart') }}</span
                      >
                      <v-text-field
                        v-model="editedUser.residencyStart"
                        :label="$t('profile.ResidencyStart')"
                        prepend-icon="event"
                        readonly
                        required
                        :rules="mandatoryRule"
                        v-on="on"
                        class="thin-border"
                        solo
                      />
                    </template>
                    <v-date-picker
                      v-model="editedUser.residencyStart"
                      @input="datePicker = false"
                    /> </v-menu
                ></v-flex>
                <v-flex xs4 class="pl-4">
                  <span class="caption grey--text text--darken-1">{{
                    $t('profile.ResidencyYear')
                  }}</span>
                  <v-text-field
                    :value="residencyYear"
                    disabled
                    :label="$t('profile.ResidencyYear')"
                    class="thin-border"
                    solo
                /></v-flex>
              </v-layout>

              <span class="caption grey--text text--darken-1">{{
                $t('profile.Institution')
              }}</span>
              <v-autocomplete
                v-model="editedUser.hospital"
                :label="$t('profile.Institution')"
                :items="institutionSelections"
                :loading="hospitalsLoading && healthCenterGroupsLoading"
                item-value="id"
                @click:clear="editedUser.hospital = 'hello'"
                item-text="name"
                dense
                clearable
                class="text-truncate thin-border"
                required
                :rules="mandatoryRule"
                solo
              />

              <v-layout wrap row justify-space-between class="px-1">
                <v-flex xs12 md5>
                  <span class="caption grey--text text--darken-1">{{
                    $t('profile.MainTutorName')
                  }}</span>
                  <v-text-field
                    v-model="editedUser.mainTutorName"
                    :label="$t('profile.MainTutorName')"
                    hint="Name"
                    class="thin-border mr-2"
                    solo
                  />
                </v-flex>
                <v-flex xs12 md7>
                  <span class="caption grey--text text--darken-1">{{
                    $t('profile.MainTutorEmail')
                  }}</span>

                  <v-text-field
                    v-model="editedUser.mainTutorEmail"
                    class="thin-border"
                    :label="$t('profile.MainTutorEmail')"
                    hint="Email"
                    solo
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <v-btn
      :disabled="!edited || !formValid"
      :loading="saveUserLoading"
      color="primary"
      depressed
      @click="putUser"
      >{{ this.$t('profile.UpdateProfile') }}</v-btn
    >
    <v-btn :disabled="!edited" depressed color="warning" @click="reset">{{
      this.$t('profile.Reset')
    }}</v-btn>
    <v-btn
      @click="resetPassword"
      :loading="resetPasswordLoading"
      color="error"
      depressed
      >Alterar palavra-passe</v-btn
    >
    <!-- <cv-generator /> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import cms from '@/content'
import ImageInput from '@/components/ImageInput'
import deepEquals from '@/utils/deepEquals'
// eslint-disable-next-line no-unused-vars
import NotificationManager from '@/services/notifications-manager'
import { Hospital, HealthCenterGroup } from '../../models/Content'

export default {
  name: 'Profile',
  components: {
    ImageInput
  },
  data() {
    return {
      saving: false,
      saved: false,
      datePicker: false,
      editedUser: null,
      saveUserLoading: false,
      hospitalsLoading: true,
      healthCenterGroupsLoading: true,
      resetPasswordLoading: false,
      formValid: false,
      avatar: ''
    }
  },
  mounted() {
    this.avatar = this.user.picture ? this.user.picture : this.profile.picture
    this.$refs.myForm.validate()
    this.$root.$on('imageUpload', event => {
      this.avatar = event
      this.savedAvatar(event)
    })
  },
  computed: {
    ...mapGetters(['profile', 'user', 'residencyYear', 'accessToken']),
    isSuperAdmin() {
      return (this.user.roles || []).includes('global-admin')
    },
    edited() {
      return !deepEquals({ ...this.user }, this.editedUser)
    },
    roleSelections() {
      return cms.getRoles(this.$i18n.locale)
    },
    institutionSelections() {
      return this.editedUser.specialty === 'family-medicine'
        ? HealthCenterGroup.query().get()
        : Hospital.query().get()
    },
    specialtySelections() {
      let specialities = cms.getSpecialties(this.$i18n.locale)
      return specialities.sort((a, b) => a.text.localeCompare(b.text))
    },
    mandatoryRule() {
      return [v => !!v || this.$t('common.RequiredField')]
    }
  },
  watch: {
    'editedUser.hospital'(val) {
      if (typeof val === 'undefined') this.editedUser.hospital = null
    }
  },
  created() {
    Hospital.fetch().finally(() => (this.hospitalsLoading = false))
    HealthCenterGroup.fetch().finally(
      () => (this.healthCenterGroupsLoading = false)
    )
    this.reset()
  },
  methods: {
    ...mapActions(['showSuccessSnackbar', 'showErrorSnackbar']),
    putUser() {
      const sameSpecialty = this.editedUser.specialty === this.user.specialty

      this.saveUserLoading = true

      const payload = { ...this.editedUser }
      if (this.editedUser.firstName && this.editedUser.lastName) {
        payload.name = `${this.editedUser.firstName} ${this.editedUser.lastName}`
      }

      this.$store.commit('setUser', payload)
      this.$store
        .dispatch('putUser')
        .then(() => (this.saveUserLoading = false))
        .then(() => {
          this.$store.dispatch('showSuccessSnackbar', 'Profile Updated')
          this.reset()
          this.$forceUpdate()

          if (!sameSpecialty) {
            this.$router.go()
          }
        })
        .catch(err => {
          this.saveUserLoading = false
          this.$store.dispatch(
            'showErrorSnackbar',
            err.message || 'Profile update error'
          )
        })
    },
    reset() {
      this.editedUser = JSON.parse(JSON.stringify(this.$store.getters.user)) // replace with proper deep clone method later
      this.editedUser.license ? null : (this.editedUser.license = '')
      this.editedUser.roles ? null : (this.editedUser.roles = [])
    },
    savedAvatar(file) {
      this.editedUser.picture = file
      this.avatar = file
    },
    resetPassword() {
      this.resetPasswordLoading = true
      return fetch(
        `${process.env.VUE_APP_API_URL}/auth0/users/${this.user.id}/tickets/password-change`,
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${this.accessToken}`
          },
          method: 'POST',
          body: JSON.stringify({
            email: this.user.email
          })
        }
      )
        .then(res => {
          if (res.ok) {
            res.json().then(result => {
              window.location.href = result.ticket
            })
          } else {
            this.$store.dispatch('showErrorSnackbar', 'Something went wrong')
          }
        })
        .catch(err => {
          this.$store.dispatch(
            'showErrorSnackbar',
            err.message || 'Something went wrong'
          )
        })
        .finally(() => {
          this.resetPasswordLoading = false
        })
    }
  }
}
</script>

<style></style>
